import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  branches: [],
};

const slice = createSlice({
  name: 'portal-branch',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.branches || state.branches.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getBranchesSuccess(state, action) {
      state.isLoading = false;
      state.branches = action.payload;
      state.isInitializing = false;
    },
  },
});

export function getBranches() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/portal/branches');
      dispatch(slice.actions.getBranchesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
